import classNames from "./ByrdhouseBanner.module.css";

const ByrdhouseBanner = () => {
  return (
    <div className={classNames.ByrdhouseBanner}>
      🎉 Byrdhouse AI is now Langfinity! New name, same magic ✨
    </div>
  );
};

export default ByrdhouseBanner;
